import React, {Component} from 'react';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Tabs from "components/CustomTabs/CustomTabs.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";


import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import InvoiceApprovalPanel from "./searchPanel";
import { store } from "../../_store";
import { alertActions, commonActions } from "../../_actions";
import { commonService } from "../../_services";
import { appConstants } from "../../_constants";
// import CircularProgress from '../../utils/CircularProgress';
// import { appHelpers } from "../../_helpers";
import moment from "moment";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import MyInvoicesTable from "./myInvoicesTable";
import AllInvoicesTable from "./allInvoicesTable";
import Receipt from "@material-ui/icons/Receipt";
import PausePresentationIcon from '@material-ui/icons/PausePresentation';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import {FormControl} from "@material-ui/core";
import InlineDatePicker from "../../utils/InlineDatePicker";
import DialogActions from "@material-ui/core/DialogActions";
import CircularProgress from "../../utils/CircularProgress";
import CheckIcon from "@material-ui/icons/Check";
import DeclineIcon from "@material-ui/icons/Close";

let monthAgo = new Date();
monthAgo.setDate(new Date().getDate() - 30);

class InvoiceApproval extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // startDate: new Date(),
      startDate: monthAgo,
      endDate: new Date(),
      myCurrentPage: 1,
      myPageSize: 10,
      totalCount: 0,
      open: false,
      airlines: [],
      AirlineId: '-1',
      airportLocation: "-1",
      locationData: [],
      dateTypes: [
        {name: "All DateType", value: "-1"},
        {
        name: "Created Date",
        Id: 0
      },
        {
          name: "Invoice Date",
          Id: 1
        },
        {
          name: "Payment Date",
          Id: 2
        },
      ],
      statusTypes: [
        {name: "All Status", value: "-1"},
        { name: "Pending", value: 0 },
        { name: "Initiate", value: 1 },
        { name: "Approved", value: 2 },
      ],
      status: "-1",
      dateType: 0,
      totalCountAllInvoices: 0,
      myInvoiceData: [],
      allPageSize:10,
      myTotalCount: 0,
      allCurrentPage: 1,
      allInvoicesData: [],
      pageRequesting: true,
      currentTab: 0,
      invoiceNumber: "",
      invoiceDate: null,
      invoiceAmount: 0,
      amountPaid: 0,
      paymentDate: null,
      airlineName: "",
      airportName: "",
      modalAirlineId: null,
      modalAirportCode: null,
      dialogTitle: "",
      pulledInvoiceId: null,
      approveRejectModal: false,
    }
  }
  componentDidMount() {
    //vvv
    let {regionalAirlines,  regionalAirports} = store.getState();
  
    const {dispatch} = this.props;
  
    if (regionalAirlines) {
      this.setState({airlines: regionalAirlines});
    } else {
      dispatch(commonActions.getAllAirlinesRegional());
    }
  
    if (regionalAirports) {
      this.setState({locationData: regionalAirports})
    } else {
      dispatch(commonActions.getAllAirportsRegional())
    }
    
    // this.searchAllPulledInvoice();
    this.searchAllPulledInvoice(1);
    this.searchMyPulledInvoices(1);
  }
  
  componentWillReceiveProps = function (nextProps) {
    const { regionalAirlines, regionalAirports } = nextProps;
    if (regionalAirlines) {
      let modifiedAirlines = [...regionalAirlines];
      let allAirlines = { Airline: "All Airlines", AirlineId: "-1" };
      modifiedAirlines.unshift(allAirlines);
      this.setState({ airlines: modifiedAirlines });
    }
    if (regionalAirports) {
      let modifiedAirports = [...regionalAirports];
      modifiedAirports.unshift({ Name: "All Airports", airportLocation: "-1" });
      this.setState({ locationData: modifiedAirports })
    }
  };
  
  handleSelectChange = prop => event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  
  handleReactSelectChange = (value, name) => {
    this.setState({ [name.name]: value });
    if (value.value === undefined || value.value === "-1" || value.value === "All Flights"){
      this.setState({[name.name]: "-1"} )
    }
  };
  
  handleClickOpen = () => {
    this.setState({ open: true });
  };
  
  handleClose = () => {
    this.resetFields();
    this.setState({ open: false });
  };
  
  handleDateChange = (date, target) => {
    this.setState({ [target]: date });
  };
  
  handleAirlineChange = prop => event => {
    this.setState({ [prop]: event.target.value });
  };
  
  
  searchAllPulledInvoice = (pageNumber, payload) => {
    const {dispatch, user} = this.props;
    const {startDate, endDate, myPageSize, AirlineId,
      airportLocation, dateType, status} = this.state;
    let fromIndex;
    if (pageNumber === undefined || pageNumber === null) {
      fromIndex = 0;
      pageNumber = 0;
    } else {
      fromIndex = (pageNumber * myPageSize) - myPageSize;
    }
    if (!payload) {
         payload = {
        From: fromIndex,
        PageSize: myPageSize,
        Parameter: {
          Startdate: moment(startDate).format('YYYY-MM-DD') + "T00:00:00",
          Enddate: moment(endDate).format('YYYY-MM-DD') + "T23:59:59",
          // DateType: dateType.value,
          NotVerifiedBy: user.userId
        }
      };
      
      if (dateType !== "-1") {
        payload.Parameter.DateType = dateType.value
      }
      
      if (status !== "-1") {
        payload.Parameter.Status = status.value
      }
  
      if (airportLocation !== "-1") {
        payload.Parameter.AirportCode = airportLocation.value
      }
  
      if (AirlineId !== "-1") {
        payload.Parameter.AirlineId = AirlineId.value
      }
    }
  
    dispatch(alertActions.startRequest());
    commonService.searchPulledInvoiceRegional(payload)
      .then((res) => {
        dispatch(alertActions.stopRequest());
        let response = res.response;
        if(res.status === appConstants.SUCCESS_RESPONSE) {
            this.setState({
              pageRequesting: false,
              totalCountAllInvoices: response.TotalCount,
              allInvoicesData: response.Results,
              allCurrentPage: (pageNumber === 0 ) ? pageNumber + 1 : pageNumber
            })
          }
        else if(res.status === appConstants.ERROR_RESPONSE){
          dispatch(alertActions.error(res.response));
          this.setState({pageRequesting: false,})
        }
        })
        .catch(err=>{
          dispatch(alertActions.error(err.response));
        })
  };
  
  searchMyPulledInvoices = (pageNumber, payload) => {
    const {dispatch, user} = this.props;
    const {startDate, endDate, myPageSize, AirlineId,
      airportLocation, dateType, status} = this.state;
    let fromIndex;
    if (pageNumber === undefined || pageNumber === null) {
      fromIndex = 0;
      pageNumber = 0;
    } else {
      fromIndex = (pageNumber * myPageSize) - myPageSize;
    }
    if (!payload) {
      payload = {
        From: fromIndex,
        PageSize: myPageSize,
        Parameter: {
          Startdate: moment(startDate).format('YYYY-MM-DD'),
          Enddate: moment(endDate).format('YYYY-MM-DD'),
          // DateType: dateType.value,
          VerifiedBy: user.userId
        }
      };
  
      if (dateType !== "-1") {
        payload.Parameter.DateType = dateType.value
      }
  
      if (status !== "-1") {
        payload.Parameter.Status = status.value
      }
  
      if (airportLocation !== "-1") {
        payload.Parameter.AirportCode = airportLocation.value
      }
  
      if (AirlineId !== "-1") {
        payload.Parameter.AirlineId = AirlineId.value
      }
    }
  
    dispatch(alertActions.startRequest());
    commonService.searchPulledInvoiceRegional(payload)
      .then((res) => {
        dispatch(alertActions.stopRequest());
        let response = res.response;
        if(res.status === appConstants.SUCCESS_RESPONSE) {
          this.setState({pageRequesting: false})
          this.setState({
            pageRequesting: false,
            myTotalCount: response.TotalCount,
            myInvoiceData: response.Results,
            myCurrentPage: (pageNumber === 0 ) ? pageNumber + 1 : pageNumber
          })
        }
        else if(res.status === appConstants.ERROR_RESPONSE){
          dispatch(alertActions.error(res.response));
          this.setState({pageRequesting: false})
        }
      })
      .catch(err=>{
        dispatch(alertActions.error(err.response));
      })
  
  }
  
  loadPulledInvoicesData = (payload) => {
    this.searchAllPulledInvoice(1, payload)
    this.searchMyPulledInvoices(1, payload)
  }
  
 openModal = (status, item) => {
   this.setState({
     open: true,
     invoiceNumber: item.InvoiceNumber,
     invoiceDate: item.InvoiceDate,
     invoiceAmount: item.Amount,
     amountPaid: item.AmountPaid,
     paymentDate: item.PaymentDate,
     modalAirlineId: item.AirlineId,
     modalAirportCode: item.AirportCode,
     airlineName: item.AirlineName,
     airportName: item.AirportName,
     pulledInvoiceId: item.Id,
     // dialogTitle: status === 1 ? "Initiate" : status === 2 ? "Approve" : "Reject"
   })
 };
  
  handleApproveRejectModal = (status, item) =>{
    this.setState({dialogTitle: status === 2 ? "Approve" : "Reject", pulledInvoiceId: item.Id,})
    this.setState(prevState => ({ approveRejectModal : !prevState.approveRejectModal}))
  }
  
  handleDismissApprovalModal = () => {
    this.setState({approveRejectModal: false})
  }
 
 initiate = () => {
   const {user, dispatch} = this.props;
   const {pulledInvoiceId, paymentDate} = this.state
   
   const payload ={
     UserId: user.userId,
     PulledInvoiceId: pulledInvoiceId,
     PaymentDate:  moment(paymentDate).format('YYYY-MM-DD'),
   }
  
   dispatch(alertActions.startRequest());
   commonService.initiatePulledInvoice(payload)
     .then(res => {
       dispatch(alertActions.stopRequest());
       if (res.status === appConstants.SUCCESS_RESPONSE) {
         dispatch(alertActions.notify(res.response.Message));
         this.searchAllPulledInvoice();
         this.setState({  open: false })
       }
       else if (res.status === appConstants.ERROR_RESPONSE) {
         dispatch(alertActions.error(res.response));
         this.setState({ errorMessage: res.response })
       }
     })
     .catch(err => {
       dispatch(alertActions.error(err.response))
     });
  
 };
 
 approve = () => {
   const {user, dispatch} = this.props;
   const {pulledInvoiceId} = this.state
  
   const payload ={
     UserId: user.userId,
     PulledInvoiceId: pulledInvoiceId,
   }
  
   dispatch(alertActions.startRequest());
   commonService.approvePulledInvoice(payload)
     .then(res => {
       dispatch(alertActions.stopRequest());
       if (res.status === appConstants.SUCCESS_RESPONSE) {
         dispatch(alertActions.notify(res.response.Message));
         this.searchAllPulledInvoice();
         this.setState({  approveRejectModal: false })
       }
       else if (res.status === appConstants.ERROR_RESPONSE) {
         dispatch(alertActions.error(res.response));
         this.setState({ errorMessage: res.response })
       }
     })
     .catch(err => {
       dispatch(alertActions.error(err.response))
     });
 };
 
 reject = () => {
   const {user, dispatch} = this.props;
   const {pulledInvoiceId} = this.state
  
   const payload ={
     UserId: user.userId,
     PulledInvoiceId: pulledInvoiceId,
   }
  
   dispatch(alertActions.startRequest());
   commonService.rejectPulledInvoice(payload)
     .then(res => {
       dispatch(alertActions.stopRequest());
       if (res.status === appConstants.SUCCESS_RESPONSE) {
         dispatch(alertActions.notify(res.response.Message));
         this.searchAllPulledInvoice();
         this.setState({  approveRejectModal: false })
       }
       else if (res.status === appConstants.ERROR_RESPONSE) {
         dispatch(alertActions.error(res.response));
         this.setState({ errorMessage: res.response })
       }
     })
     .catch(err => {
       dispatch(alertActions.error(err.response))
     });
 };
 
 resetFields = () => {
   this.setState({
     InvoiceNumber: "",
     invoiceDate: null,
     invoiceAmount: 0,
     amountPaid: 0,
     paymentDate: null,
     airlineName: "",
     airportName: "",
     AirlineId: "-1",
     pulledInvoiceId: null
     
   })
 };
  
  selectedTab = (key) => {
     this.setState({currentTab: key})
  };
  
  render() {
    const { classes, user, fullScreen} = this.props;
    const {
      airlines,
      AirlineId,
      airlineName,
      startDate,
      endDate,
      myCurrentPage,
      myPageSize,
      airportLocation,
      locationData,
      myInvoiceData,
      allCurrentPage,
      totalCountAllInvoices,
      allInvoicesData,
      dateTypes,
      dateType,
      invoiceNumber,
      invoiceDate,
      invoiceAmount,
      amountPaid,
      paymentDate,
      dialogTitle,
      airportName,
      statusTypes,
      status,
      pageRequesting,
      approveRejectModal
    } = this.state;
  
    if (pageRequesting)
      return (
        <CircularProgress />
      );
    
    return (
      <GridContainer>
        <InvoiceApprovalPanel
          user={this.props.user}
          airline={airlineName}
          AirlineId={(this.props.user.AppRole === appConstants.ROLES.AIRLINE ? AirlineId : AirlineId.value)}
          selectChange={(e, name) => this.handleReactSelectChange(e, name)}
          // selectChange={this.handleSelectChange("airlines")}
          data={airlines}
          dateTypes={dateTypes}
          dateType={dateType.value}
          onSearch={this.loadPulledInvoicesData}
          startDate={startDate}
          endDate={endDate}
          startLabel='Start Date'
          endLabel='End Date'
          handleDateChange={this.handleDateChange}
          handleEndDateChange={this.handleDateChange}
          airportLocation={(this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location) ? airportLocation : airportLocation.value}
          locationData={locationData}
          statusTypes={statusTypes}
          status={status.value}
        />
        <Tabs
          headerColor="regional"
          tabs={[
            {
              tabName: "My Invoices",
              tabIcon: Receipt,
              clickEvent: (key) => this.selectedTab(key),
              tabContent: (
                <GridItem xs={12} sm={12} md={12}>
                  <MyInvoicesTable
                    records = {myInvoiceData}
                    fetchRecords = {this.searchMyPulledInvoices}
                    classes={classes}
                    totalCounts={this.state.myTotalCount}
                    // filterUsers={this.filterUsers}
                    currentPage={myCurrentPage}
                    pageSize={myPageSize}
                    user={this.props.user}
            
                  />
                </GridItem>
              )
            },
            {
              tabName: "All Invoices",
              tabIcon: PausePresentationIcon,
              clickEvent: (key) => this.selectedTab(key),
              tabContent: (
                <GridItem xs={12} sm={12} md={12}>
                  <AllInvoicesTable
                    handleApprove = {this.handleApprove}
                    records = {allInvoicesData}
                    fetchRecords = {this.searchAllPulledInvoice}
                    // handleEdit = {this.handleEdit}
                    openModal={this.openModal}
                    classes={classes}
                    totalCounts={totalCountAllInvoices}
                    filterUsers={this.filterUsers}
                    currentPage={allCurrentPage}
                    pageSize={myPageSize}
                    user={this.props.user}
                    handleApproveRejectModal={this.handleApproveRejectModal}
                  />
          
                </GridItem>
              )
            }
          ]}
        />
        {/*Initiate, Approve, Reject Modal*/}
        <Dialog
          fullScreen={fullScreen}
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: "#66bb6a" }}>
            <span style={{ color: "white", textTransform: "uppercase" }}> Initiate</span>
          </DialogTitle>
          <DialogContent>
            <GridContainer>
              <GridItem md={12} sm={12}>
                <CustomInput
                  
                  labelText="Invoice Number"
                  id="invoiceNumber"
                  disabled
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={
                    {
                      required: true,
                      value: invoiceNumber,
                      name: "invoiceNumber",
                      type: "text",
                      disabled: true
                      // onChange: this.handleChange,
                    }}
                 
                />
              </GridItem>
              <GridItem md={12} sm={12}>
                <CustomInput
      
                  labelText="Invoice Date"
                  id="invoiceNumber"
                  disabled
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={
                    {
                      required: true,
                      // value: invoiceDate !== null && invoiceDate.slice(0, 10),
                      value: invoiceDate !== null &&  moment(invoiceDate).format('YYYY-MM-DD'),
                      name: "invoiceDate",
                      type: "text",
                      disabled: true
                      // onChange: this.handleChange,
                    }}
    
                />
              </GridItem>
              {/*<GridItem md={12} xs={12}>*/}
              {/*  <div*/}
              {/*    style={{width: "100%"}}*/}
              {/*  >*/}
              {/*    <FormControl*/}
              {/*      style={{width: "100%"}}*/}
              {/*      disabled={true}*/}
              {/*    >*/}
              {/*      <InlineDatePicker*/}
              {/*        Date={invoiceDate}*/}
              {/*        disabled*/}
              {/*        // handleDateChange={handleDateChange}*/}
              {/*        handleDateChange={date =>*/}
              {/*          this.handleDateChange(date, "null")*/}
              {/*        }*/}
              {/*        label="Invoice Date"*/}
              {/*      />*/}
              {/*    </FormControl>*/}
              {/*  </div>*/}
              {/*</GridItem>*/}
              <GridItem md={12} sm={12}>
                <CustomInput
                  labelText="Invoice Amount"
                  disabled
                  id="invoiceAmount"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={
                    {
                      required: true,
                      value: invoiceAmount,
                      name: "invoiceAmount",
                      type: "number",
                      onChange: this.handleChange,
                      disabled: true
                    }}
                />
              </GridItem>
              <GridItem md={12} sm={12}>
                <CustomInput
                  labelText="Amount Paid"
                  disabled
                  id="amountPaid"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={
                    {
                      required: true,
                      value: amountPaid,
                      name: "amountPaid",
                      type: "number",
                      onChange: this.handleChange,
                      disabled: true
                    }}
                />
              </GridItem>
              <GridItem md={12} sm={12}>
                <CustomInput
                  labelText="Airline"
                  disabled
                  id="AirlineId"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={
                    {
                      required: true,
                      value: airlineName,
                      name: "airlineName",
                      type: "text",
                      onChange: this.handleChange,
                      disabled: true
                    }}
                />
              </GridItem>
              <GridItem md={12} sm={12}>
                <CustomInput
                  labelText="Airport"
                  disabled
                  id="locationData"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={
                    {
                      required: true,
                      value: airportName,
                      name: "airportName",
                      type: "text",
                      onChange: this.handleChange,
                      disabled: true
                    }}
                />
              </GridItem>
              <GridItem md={12} xs={12}>
                <div
                  style={{width: "100%"}}
                >
                  <FormControl
                    style={{width: "100%"}}
                  >
                    <InlineDatePicker
                      Date={paymentDate}
                      // handleDateChange={handleDateChange}
                      handleDateChange={date =>
                        this.handleDateChange(date, "paymentDate")
                      }
                      label="Payment Date"
                    />
                  </FormControl>
                </div>
              </GridItem>
            </GridContainer>
          </DialogContent>
          <DialogActions>
            {
              <Button onClick={this.initiate} color="primary" autoFocus>
                Initiate
              </Button>
            }
            <Button onClick={this.handleClose} color="danger">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
  
        {/*//Approve/Reject Modal*/}
        <Dialog
          fullWidth={true}
          maxWidth={'sm'}
          open={approveRejectModal}
          onClose={()=>{}}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title" style={{ color: `${appConstants.PRIMARY_COLOR}` }}>
            <div>
              <span style={{ color: `${appConstants.PRIMARY_COLOR}`}}> {
                dialogTitle
                }</span>
            </div>
          </DialogTitle>
          <DialogContent style={{ marginTop: "20px" }}>
            {
              dialogTitle === "Approve" &&
              (<div>
                <h1 style={{margin: 0, textAlign: 'center'}}>
                  <CheckIcon style={{color: `${appConstants.PRIMARY_COLOR}`, fontSize: '60px'}}/>
                </h1>
                <p style={{margin: 0, textAlign: 'center'}}>
                  Are you sure you want to approve record?
                </p>
              </div>)
            }
            {
              dialogTitle === "Reject" &&
              (<div>
                <h1 style={{margin: 0, textAlign: 'center'}}>
                  <DeclineIcon style={{color: `${appConstants.DANGER_COLOR}`, fontSize: '60px'}}/>
                </h1>
                <p style={{margin: 0, textAlign: 'center'}}>
                  Are you sure you want to decline record?
                </p>
              </div>)
            }
            <div style={{textAlign: 'center'}}>
              {
                dialogTitle === "Approve" &&
                <Button disabled={this.props.requesting} onClick={this.approve} color="primary" autoFocus>
                  Ok Continue
                </Button>
              }
              {
                dialogTitle === "Reject" &&
                <Button disabled={this.props.requesting} onClick={this.reject} color="Danger" autoFocus>
                  Ok Continue
                </Button>
              }
              {/*<Button*/}
              {/*  disabled={ Comment === ""}*/}
              {/*  onClick={this.handleApproval} color={'primary'}>*/}
              {/*  Ok, continue*/}
              {/*</Button>*/}
              &nbsp;<Button onClick={this.handleDismissApprovalModal} color={'danger'}>
              Dismiss
            </Button>
            </div>
          </DialogContent>
  
        </Dialog>
      </GridContainer>
    );
  }
}


function mapStateToProps(state) {
  const { alert, regionalAirlines, progress, airlinesPayments, user, regionalAirports, requesting } = state;
  return {
    user,
    alert,
    regionalAirlines,
    progress,
    airlinesPayments,
    regionalAirports,
    requesting
  };
}
export default connect(mapStateToProps)(withMobileDialog()(withStyles(dashboardStyle)(InvoiceApproval)));




// WEBPACK FOOTER //
// ./src/Regional-Views/InvoiceApproval/Index.js